import { Injectable } from '@angular/core';

import { LOCAL_STORAGE_KEY } from '@careconne/core/configs';
import { UserSession } from '@careconne/core/models/interfaces';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  getKeys(): string[] {
    return Object.keys(localStorage);
  }

  getItem<T = any>(key: string): T {
    const value = localStorage.getItem(key);
    try {
      return JSON.parse(value!);
    } catch (e) {
      return value as unknown as T;
    }
  }

  setItem<T>(key: string, value: T): void {
    if (value == null) {
      this.removeItem(key);
      return;
    }
    localStorage.setItem(key, JSON.stringify(value));
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  removeItems(keys: string[]): void {
    keys.forEach((key) => this.removeItem(key));
  }

  trigger<T = any>(key: string, value: T | boolean = true): void {
    this.setItem(key, value);
    this.removeItem(key);
  }

  clear(exclude: string[] = []) {
    this.getKeys().forEach((key) => {
      if (!exclude.includes(key)) {
        this.removeItem(key);
      }
    });
  }

  hasKey(key: string): boolean {
    return this.getKeys().includes(key);
  }

  setUserSession(value: UserSession): void {
    this.setItem(LOCAL_STORAGE_KEY.userSession, value);
  }

  getAccessToken(): string | null {
    const userSession = this.getUserSession();
    return userSession ? userSession.accessToken : null;
  }

  getRefreshToken(): string | null {
    const userSession = this.getUserSession();
    return userSession ? userSession.refreshToken : null;
  }

  getUserSession(): UserSession {
    return this.getItem<UserSession>(LOCAL_STORAGE_KEY.userSession);
  }
}
